<template>
  <base-widget
    title="24-Hour performance"
  >
    <div class="float-right d-flex my-3">
      <base-text>
        Opens<span
          class="legend-circle"
          :style="`background-color: ${loading ? loadingColor : opensColor}`"
        />
      </base-text>
      <base-text>
        Clicks<span
          class="legend-circle"
          :style="`background-color: ${loading ? loadingColor : clicksColor}`"
        />
      </base-text>
    </div>
    <div class="px-2 mb-5">
      <simple-line-chart
        :chartdata="chartData"
        :options="lineChartOptions"
        :styles="{height: `${lineChartOptions.height}px`}"
      />
    </div>
  </base-widget>
</template>
<script>
import styles from '@/styles/_variables.scss';
import SimpleLineChart from '@/components/charts/SimpleLineChart';

export default {

  name: 'OutReach24HourPerformance',
  components: {
    SimpleLineChart,
  },
  props: {
    clicks: {
      type: Array,
      default: () => ([]),
    },
    opens: {
      type: Array,
      default: () => ([]),
    },
    labels: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opensColor: '#E9AD7D',
      clicksColor: '#E6A0A0',
      loadingColor: '#EEEEEE',

      lineChartOptions: {
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0,
              fontSize: 13,
              fontFamily: styles.fontFamilySansSerifLight,
              fontColor: '#646464',
              callback(value, index, values) {
                return `${value}     `;
              },
            },
            gridLines: {
              color: '#CCCCCC',
              drawBorder: false,
              drawTicks: true,
              tickMarkLength: 3,
              zeroLineColor: '#333333',
              zeroLineWidth: 1,
            },
          }],
          xAxes: [{
            gridLines: {
              display: false,
              drawTicks: false,
            },
            ticks: {
              display: true,
              autoskip: false,
              minRotation: 0,
              maxRotation: 0,
              fontSize: 13,
              fontFamily: styles.fontFamilySansSerifLight,
              fontColor: '#646464',
              padding: 6,
              callback(value, index, values) {
                return `${index % 4 === 0 ? value : ''}`;
              },
            },
          }],
        },
        tooltips: {
          enabled: true,
          titleFontFamily: styles.fontFamilySansSerif,
          titleFontSize: 12,
          titleFontColor: '#FFFFFF',
          titleAlign: 'center',
          titleSpacing: 10.6,
          callbacks: {
            label: () => (''),
            title: (tooltipItem, data) => {
              const eventSet = [this.opens, this.clicks][tooltipItem[0].datasetIndex];
              const element = eventSet[tooltipItem[0].index];
              const values = tooltipItem.map((item) => {
                const datasetName = data.datasets[item.datasetIndex].label;
                return `${item.value} ${datasetName}`;
              });
              const valuesString = values.join(' ');

              return `${element.title}\nSent on ${element.time_formatted}\n${valuesString}`;
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        // Custom setting
        height: 400,
      },
    };
  },
  computed: {
    chartData() {
      const commonOptions = {
        lineTension: 0,
        pointStyle: 'circle',
        pointRadius: 2.8,
        borderWidth: 0,
        borderColor: '#00000000',
      };
      return {
        labels: this.labels,
        datasets: [{
          label: 'Opens',
          data: this.opens.map((entry) => (this.loading ? 0 : entry.value)),
          backgroundColor: this.loading ? this.loadingColor : `${this.opensColor}64`,
          ...commonOptions,
        },
        {
          label: 'Clicks',
          data: this.clicks.map((entry) => (this.loading ? 0 : entry.value)),
          backgroundColor: this.loading ? this.loadingColor : `${this.clicksColor}88`,
          ...commonOptions,
        },
        ],
      };
    },
  },
};
</script>
<style scoped>
.legend-circle {
    border-radius: 50%;
    height: 8px;
    width: 8px;
    line-height: 0px;
    display: inline-block;
    margin-left: 0.5rem;
    margin-right: 1rem;
    /* margin-bottom: -0.4rem; */
}
</style>
